import { z } from 'zod'

export const ADMINORGCREDITSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgCreditsPostResponseSchema = z.unknown()
export type AdminOrgCreditsPostResponse = z.infer<typeof adminOrgCreditsPostResponseSchema>
